<ng-container *ngFor="let step of visibleSteps; let index = index">
  <ng-container *ngIf="index === stepIndex">
    <div>
      <img *ngIf="step.imageSrc" class="image" [src]="step.imageSrc" alt="image" />
    </div>

    <div class="bottom-block">
      <tui-avatar *ngIf="step.iconSrc" class="icon" [src]="step.iconSrc" appearance="primary" size="l"></tui-avatar>

      <div *ngIf="step.title" class="title">
        {{ step.title }}
      </div>

      <div *ngIf="step.description" class="description">
        {{ step.description }}
      </div>

      <div class="buttons">
        <button
          *ngIf="step.buttons.left as leftButton"
          tuiButton
          type="button"
          appearance="primary"
          [size]="tuiElementLargeSize"
          (click)="leftButton.action()"
        >
          {{ leftButton.text }}
        </button>

        <button
          *ngIf="step.buttons.right as rightButton"
          tuiButton
          type="button"
          appearance="flat"
          [size]="tuiElementLargeSize"
          (click)="rightButton.action()"
        >
          {{ rightButton.text }}
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>
